<template>
    <div class="userInfo-wrapper" v-if="order.contract_seal">
        <div class="userInfo-border">
            <h5>合同盖章信息    <el-button v-if="Acs('/order-contract-seal/create')" type="primary" size="mini" @click="showContractDialog('supplement', {order_id: order.id})">补充合同</el-button></h5>
            <el-table :data="list" border :header-cell-style="{background: '#f3faff'}" style="margin:20px; width:97%">
                <el-table-column prop="type_str" label="合同类型"></el-table-column>
                <el-table-column prop="handle_at" label="要求处理时间"></el-table-column>
                <el-table-column prop="is_logistic_str" label="需要寄件"></el-table-column>
                <el-table-column prop="is_handle_str" label="处理状态"></el-table-column>
                <el-table-column prop="is_delete_str" label="是否作废"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="Acs('/order-contract-seal/delete') && scope.row.is_handle != 1 && scope.row.is_delete != 1" @click="deleteContract(scope.row)" type="text" size="small">作废</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <ContractSealForm :dialog_visible="dialog_visible" :params="model" :show_type="show_type" @close="closeDialog" @submit="submitForm" @address-added="handleAddressAdded"></ContractSealForm>
        </div>
    </div>
</template>
<script>
    import OrderContractSealService from "~/services/OrderContractSeal";
    import CommonService from "~/services/common";
    import ContractSealForm from "~/views/order/dialog/contractSealForm.vue";
    export default {
        components: {
            ContractSealForm
        },
        props: {
            order: {
                required: true
            },
        },

        data() {
            return {
                list: [],
                loading: false,
                dialog_visible: false,
                model: {},
                show_type: '',
            }
        },

        computed: {
            
        },

        created() {
            this.list = _.clone(this.order.contract_seal);
        //    this.getList({order_id: this.order.id});
        },

        methods: {
            //获取列表
            getList(params) {
                // loading 动画
                this.loading = true;
                CommonService.getOrderContractSeal(params).then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    this.loading = false;
                }).catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            },

            showContractDialog(type = '', row = {}){
                this.model = row;
                this.show_type = type;
                this.dialog_visible = true;
            },

            closeDialog(){
                this.model = {};
                this.dialog_visible = false;
            },

            submitForm(){
                this.closeDialog();
                this.getList({order_id: this.order.id, sort_type: 1});
                this.$emit('refresh-order');
            },

            handleAddressAdded(addressData) {
                // 当地址添加成功后，通知父组件刷新地址列表
                this.$emit('address-added', addressData);
            },

            deleteContract(row){
                this.$confirm("确定作废此合同？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    OrderContractSealService.delete({ids: [row.id]}).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message:'作废成功',
                                type:'success'
                            });
                        }
                       this.getList({order_id: this.order.id});
                    })
                })
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_contract_seal.vue